import React, {useContext} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';


export function DriverListSelectCapital({attr, additionalOptions, ...props}) {

  const applicationModel = useContext(ModelContext);
  const drivers = applicationModel.getValue('drivers');

  let driverOptions = drivers ? drivers.filter(driver => {
    return driver.status === 'Active';
  }).map(driver => {
  		let nameVal = driver.nameInfo.surname.toUpperCase()+","+driver.nameInfo.givenName.toUpperCase();
  		if(driver.nameInfo.otherGivenName)
  			nameVal = nameVal+","+driver.nameInfo.otherGivenName.toUpperCase();
  		if(driver.nameInfo.suffixCd)
  			nameVal = nameVal+","+driver.nameInfo.suffixCd.toUpperCase();
        return ({
          value: `${nameVal}`,
          name: `${driver.nameInfo.surname}, ${driver.nameInfo.givenName}`
        })
  }) : [];

  if (additionalOptions && additionalOptions.length) {
    driverOptions = [...driverOptions, ...additionalOptions];
  }

  return <PortalSelect {...props}>
    {
      driverOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>)
    }
  </PortalSelect>;
}

DriverListSelectCapital.schema = BASIC_ELEMENT_SCHEMA;